import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserAlt } from "@fortawesome/free-solid-svg-icons";

const Profile = ({onToggle}) => {
  return (
    <Link
    onClick={onToggle}
      to={"profile"}
      className="flex gap-2 text-purple-500 hover:text-purple-600 cursor-pointer"
    >
        <FontAwesomeIcon icon={faUserAlt} size="lg" /> Profile
    </Link>
  );
};

export default Profile;
